// extracted by mini-css-extract-plugin
module.exports = {"notification":"notification-1s_wk","icon":"icon-2rbBe","content":"content-2Q1d7"};